import { createReducer } from "redux-starter-kit";

const initialState = {
  isAuthenticated: false,
  accessToken: null,
  idToken: null,
  email: null,
  name: null,
  avatar: null,
  referenceId: null,
  roles: [],
  exp: null
};

const authReducer = createReducer(initialState, {
  SIGNIN_SUCCESS: (state, action) => ({
    isAuthenticated: true,
    accessToken: action.payload.tokens.accessToken.toString(),
    idToken: action.payload.tokens.idToken.toString(),
    email: action.payload.tokens.idToken.payload.email,
    name: action.payload.tokens.idToken.payload.name,
    roles: action.payload.tokens.accessToken.payload['cognito:groups'],
    exp: action.payload.tokens.accessToken.payload.exp
  }),
  SIGNOUT_SUCCESS: (state, action) => initialState
});

export default authReducer;
